// extracted by mini-css-extract-plugin
export default {"Container":"denied_Container__pumg1","modal":"denied_modal__9-czG","bounce":"denied_bounce__SGmxL","overlay":"denied_overlay__QtwhR","wrapper":"denied_wrapper__I3rgf"};